import React from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css"; // Survey.js v2 CSS dosyası

const SurveyPreview = ({ surveyData }) => {
  if (!surveyData) return <p>Loading survey preview...</p>;

  const surveyModel = new Model(surveyData);
  // surveyModel.mode = "display"; // Önizleme modunda anket

  return <Survey model={surveyModel} />;
};

export default SurveyPreview;
